import React from 'react';
import { IconButton, ProductCode, ProductImage, ProductPrice } from '..';
import { CartIconNew, DeleteIconNew, DeleteWhiteIconNew, TrashWhiteIconNew, deleteIcon } from '../../../style/images';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';
import{ getProductDescription } from '../../util';
import { Box } from '@mui/material';

export const LastAddedItem = ( { deleteFromCart, lastItem,accessorylength } ) => {
  const code = lastItem.superCodeLSO?lastItem.superCodeLSO:lastItem.additionalProducts && lastItem.additionalProducts.length > 0 ? `${ lastItem.code } + ${lastItem.additionalProducts[0].code}` : lastItem.code;
  const lastItemName = lastItem.superCodeLSO && lastItem.NST_description?<span style={{color:"green"}} >{lastItem.NST_description}</span>:lastItem.additionalProducts && lastItem.additionalProducts.length > 0 ? getProductDescription( lastItem ) + ' + ' + getProductDescription( lastItem.additionalProducts[0]) : getProductDescription( lastItem );
  return <div className="last-added-item-panel">
    <Box sx={{display:"flex", flexDirection:"column"}} width="100%" height="100%">
    <Box height="52px" width="100%" sx={{padding: "16px 247px 16px 24px", display:"flex", alignItems:"center", whiteSpace:"nowrap"}}>
      <span className="last-added-item-title" >{ translate( 'Last item added' ) }</span>
    </Box>
    <Box sx={{display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"start", gap:"8px"}} width="100%" height="96px" borderBottom="1px solid #EBEBEB">
    <div className="last-added-item" >
        <Box  padding="5px" margin="0px 12px" width="15%" justifyContent="center" alignItems="center" 
          >
          <div className="product-image-panel">
              <ProductImage className="full-image" product={ lastItem } alt={ lastItem.name } />
          </div>
        </Box>
        <Box sx={{display:"flex", flexDirection:"column", width: "60%"}}>
          <div className='left'>
            <ProductCode name={ lastItem.name } code={ code } aliases={ lastItem.aliases } productLink={ lastItem.productLink } accessorylength= {accessorylength} />
            <span> { lastItemName } </span>
            { <ProductPrice lastAddedItem products={ [lastItem] } /> }
          </div>
        </Box>
        <IconButton
          icon={ TrashWhiteIconNew }
          className="round-button"
          onClick={ deleteFromCart }
          tooltip={ translate( 'Remove' ) }
          // text={ translate( 'Remove' ) }
        /> 
        {/* <ProductCode name={ lastItem.name } code={ code } aliases={ lastItem.aliases } productLink={ lastItem.productLink } />
        { <ProductPrice lastAddedItem products={ [lastItem] } /> }
        <IconButton
          icon={ deleteIcon }
          className="delete-button"
          onClick={ deleteFromCart }
          tooltip={ translate( 'Remove' ) }
          text={ translate( 'Remove' ) }
        /> */}
    </div>
    </Box>
    </Box>
  </div>;
};

LastAddedItem.propTypes = {
  deleteFromCart: PropTypes.func.isRequired,
  lastItem: PropTypes.shape( {
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number
  } )
};